import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { AppNotification, NotificationService } from '../../services/notification.service';
import { NotificationComponent } from '../notification/notification.component';

@Component({
    selector: 'app-notification-container',
    standalone: true,
    imports: [CommonModule, NotificationComponent],
    templateUrl: './notification-container.component.html',
    styleUrls: ['./notification-container.component.scss']
})
export class NotificationContainerComponent {
    @Input() notifications: AppNotification[] = [];

    constructor(private readonly notificationService: NotificationService) {}

    onClose(id: string): void {
        this.notificationService.dismiss(id);
    }
}
